import React from 'react';

const AnalyticsPage = React.lazy(() => import('pages/analytics'));

const policies = [{ resource: 'trends', action: 'view' }];

export const definitions = [
  {
    index: true,
    policies: policies,
    component: <AnalyticsPage />
  }
];
